import { AbsDistributorNotice } from './AbsDistributorNotice';
export class DistributorNoticePost extends AbsDistributorNotice {
    createReqBody() {
        return {
            title: this.reqBody.title,
            body: this.reqBody.body,
        };
    }
}
